import { PhotoDTO } from 'entities/counterparties/model/dtoTypes'
import { Photo } from 'entities/counterparties/model'

export const adaptDocumentPhotos = (dto: PhotoDTO): Photo => ({
    hashName: dto?.hash_name ?? null,
    readUrl: dto?.read_url ?? null,
    fileName: dto?.file_name ?? null,
})
